import './style.scss';
import Header from "../SharedComponents/Header";
import {ReactComponent as ShareIcon }from "../assets/icons/shareIcon.svg";
import {ReactComponent as FileIcon} from  "../assets/icons/fileIcon.svg";
import {ReactComponent as Facebook} from  "../assets/icons/facebook.svg";
import {ReactComponent as Youtube} from  "../assets/icons/youtube.svg";
import {ReactComponent as LinkedIn} from  "../assets/icons/linkedIn.svg";
import {ReactComponent as GooglePuls} from  "../assets/icons/g+.svg";
import {ReactComponent as Website} from  "../assets/icons/website.svg";
import {ReactComponent as Instagram} from  "../assets/icons/instagram.svg";
import {ReactComponent as Twitter} from  "../assets/icons/twitter.svg";
import Score from "../SharedComponents/Score";

export default function didbanShare(){
    return (
        <div className="main-container">
            <Header />
            <div className="didban-share">
                <h2>معرفی فیدیما به سایرین</h2>
                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.</p>
                <h2>در مورد محصول</h2>
                <textarea placeholder="مثال برداشت" />
                <h2>لینک</h2>
                <div className="input-section">
                    <button>
                        <ShareIcon/>
                        </button>
                        <input type="text" placeholder="LINK EXAMPLE"/>
                    <button><FileIcon/></button>
                </div>
                <div className="social-group">
                    <button><Website/></button>
                    <button><LinkedIn/></button>
                    <button><GooglePuls/></button>
                    <button><Youtube/></button>
                    <button><Instagram/></button>
                    <button><Twitter/></button>
                    <button><Facebook/></button>
                </div>
                <Score size="big" score={4} title={true}/>
             </div>
        </div>
       
    )
}